import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { TransactionInfoType } from '@app/finxone-web-frontend/app/lib/services/account-service/account.type';
import { CardManagementState } from '@app/finxone-web-frontend/app/lib/state/card-management.state';
import { TransactionState } from '@app/finxone-web-frontend/app/lib/state/transaction.state';
import { scrollLoading } from '@app/finxone-web-frontend/app/lib/utils/scrolling-utils/scrolling.utils';
import {
  cardTransactionHistoryItemTemplate,
  exchangeTransactionHistoryItemTemplate,
  transactionHistoryItemTemplate,
} from '@finxone-platform/shared/default-templates';
import { CardTransactionInfoType } from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import { PageConfigurationProvider } from '@app/finxone-web-frontend/app/Modules/zones/page-configuration.provider';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-transaction-history',
  templateUrl: './transaction-history.component.html',
  styleUrls: ['./transaction-history.component.scss'],
})
export class TransactionHistoryComponent implements OnChanges {
  @Input() public transactionData: any;
  @Input() public transactionTemplate =
    transactionHistoryItemTemplate ||
    exchangeTransactionHistoryItemTemplate ||
    cardTransactionHistoryItemTemplate;
  @Input() public imageEnabled: boolean;
  @Input() public symbolCreditDebitMargin: {
    marginTop: number;
    marginBottom: number;
    marginLeft: number;
    marginRight: number;
    marginUnit: string;
  };
  @Input() enableClickableRow = false;
  @Input() widgetAttributes: any;
  @Output() scrolled = new EventEmitter<void>();
  @Output() handleTransactionRowClick = new EventEmitter<any>();
  @Output() handleActionClick = new EventEmitter<any>();
  headerHeight: number;

  public containerHeight: string;

  // a linked list takes each row's box from the theme's List styling; the row item itself is display: contents
  public get isGlobalStylingEnabled(): boolean {
    return !!this.widgetAttributes?.widgetProperties?.globalStyling;
  }
  public templateContainsIcons: boolean;

  constructor(private el: ElementRef, private store: Store, public pageConfig: PageConfigurationProvider) {}

  ngOnChanges(changes: SimpleChanges): void {
    //Based on the grid height of the widget, the max-height will be set dynamically instead of being static, ensuring the scrollable area functions properly.
    setTimeout(() => {
      const header = document.querySelector('.transaction-header');
      this.headerHeight = header ? header.scrollHeight : 1;
    }, 10);
    this.templateContainsIcons = !!this.transactionTemplate?.includes('credit-symbol');

    if (changes['transactionData']) {
      setTimeout(() => {
        // Transaction Data has changed so at the end of the call stack update the container height.
        this.containerHeight = scrollLoading('transaction-list', this.el);
      });
    }
  }

  @HostListener('scroll', ['$event'])
  onScroll(event: Event) {
    const element = event.target as HTMLElement;
    const scrollPercentage = (element.scrollTop / (element.scrollHeight - element.clientHeight)) * 100;

    if (scrollPercentage <= 80) {
      return;
    }

    const txLoading = this.store.selectSnapshot(TransactionState.getLoadingStatus);
    const cardLoading = this.store.selectSnapshot(CardManagementState.getLoadingStatus);

    if (!txLoading || !cardLoading) {
      this.scrolled.emit();
    }
  }

  public buildTransactionHandlebarModel(
    txData: TransactionInfoType | CardTransactionInfoType,
    first: boolean,
    last: boolean,
    index: number,
  ): any {
    const prevTrans = index > 0 ? this.transactionData[index - 1] : null;
    return {
      ...txData,
      isFirstEntry: first,
      isLastEntry: last,
      index,
      previousTransaction: prevTrans,
    };
  }

  public onClickRow(transactionData: any) {
    if (this.enableClickableRow) {
      this.handleTransactionRowClick.emit(transactionData);
    }
  }

  public onActionTriggered(actionEvent: any, transactionData: any): void {
    const navigationOptionConfig =
      actionEvent?.config?.navigationOptionConfig ?? actionEvent?.navigationOptionConfig ?? null;
    this.handleActionClick.emit({ transactionData, navigationOptionConfig });
  }
}
